import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { QuoteLayout } from '@/components/quotes/QuoteLayout';
import { canOpenQuotePage, firstAllowedQuotePath } from '@/lib/quotePermissions';

/**
 * Sends a staff member who cannot open `page` to the first page they can
 * open; if there is none, shows a short "no access" note.
 */
export function QuotePermissionGate({ page, children }) {
  const { user } = useAuth();
  const { t } = useTranslation('quotes');
  if (canOpenQuotePage(user, page)) return children;
  const fallback = firstAllowedQuotePath(user);
  if (fallback && fallback !== page) return <Navigate to={fallback} replace />;
  return (
    <QuoteLayout>
      <div className="max-w-xl mx-auto mt-16 rounded-2xl border border-[#E5E5E5] bg-white p-8 text-center" data-testid="quote-no-access">
        <h1 className="text-lg font-semibold text-[#1A1A2E] mb-2">{t('team.noAccess.title')}</h1>
        <p className="text-sm text-[#595959]">{t('team.noAccess.body')}</p>
      </div>
    </QuoteLayout>
  );
}
